import axios from 'axios'
import store from '@/store/index.js'
const state = {
    loggedIn: false,
    profile: {},
    validation: { email: true },
    authError: false,
    token: null 
}

const getters = {}

const mutations = {
    login(state) {
        state.loggedIn = true
    },
    logout(state) {
        state.loggedIn = false
        state.profile = null
        state.token = null
        store.commit('setTags', [])
        store.commit('setPhotos', [])
        store.commit('setJobs', [])
        store.commit('setProjects', [])
        store.commit('setFilteredTags', [])
        store.commit('setCategories', [])
        store.commit('setResponseIds', [])
        store.commit('setTaggerResponseIds', [])

    },
    setProfile(state, payload) {
        state.profile = payload
    },
    setValidationEmail(state, bool) {
        state.validation.email = bool
    },
    setAuthError(state, bool) {
        state.authError = bool
    },
    setToken(state, val) {
        state.token = val
    },
    
}

const actions = {
    
    postLogin(context, payload) {
        return axios.post('/api/users/login/', payload)
            .then(response => {
                context.commit('login');
                context.commit('setProfile', response.data)
                context.commit('setToken', response.data['token'])
            })
            .catch(e => {
                context.commit('setAuthError', true)
                console.log(e)
            })
    },
    postPasswordReset (context, payload) {
      return axios.post('/api/users/password_reset/', payload)
        .catch(e => {
          context.commit('setAuthError', true)
          console.log(e)
        })
    },
    postRegister(context, payload) {
        return axios.post('/api/users/register/', payload)
            .then(response => {
                if (response.data.status === 210) {
                    context.commit('setValidationEmail', false)
                } else {
                    context.commit('setValidationEmail', true)
                    context.rootState.users.users.push(response.data)
                }
            })
            .catch(e => { console.log(e) })
    },
    getProfile(context) {
        return axios.get('/api/users/profile')
            .then(response => {
                context.commit('login')
                context.commit('setProfile', response.data)
            })
            .catch(e => {
                context.commit('logout')
                console.log(e)
            })
    }
    
}

export default {
    state,
    getters,
    mutations,
    actions
}